exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Buildings-module__top___ezHTV{grid-area:1/1/1/1;margin:auto 0 0}.Buildings-module__top___ezHTV.Buildings-module__red___2FLfk .Buildings-module__medium___3qwkj{fill:#eb3863}.Buildings-module__top___ezHTV.Buildings-module__blue___3myd0 .Buildings-module__medium___3qwkj{fill:#526df6}.Buildings-module__top___ezHTV.Buildings-module__yellow___zgJOI .Buildings-module__medium___3qwkj{fill:#f3c000}.Buildings-module__top___ezHTV.Buildings-module__orange___2tTYq .Buildings-module__medium___3qwkj{fill:#f1ab48}.Buildings-module__top___ezHTV.Buildings-module__sand___2E4UV .Buildings-module__medium___3qwkj{fill:#e7d9d3}.Buildings-module__top___ezHTV.Buildings-module__mint___3Tsy5 .Buildings-module__medium___3qwkj{fill:#59c6b9}.Buildings-module__top___ezHTV.Buildings-module__green___RlU0O .Buildings-module__medium___3qwkj{fill:#42d06f}.Buildings-module__top___ezHTV.Buildings-module__purple___3MlM5 .Buildings-module__medium___3qwkj{fill:#7c3eb0}.Buildings-module__top___ezHTV.Buildings-module__black___14H0B .Buildings-module__medium___3qwkj{fill:#2f2f2f}", ""]);

// exports
exports.locals = {
	"top": "Buildings-module__top___ezHTV",
	"red": "Buildings-module__red___2FLfk",
	"medium": "Buildings-module__medium___3qwkj",
	"blue": "Buildings-module__blue___3myd0",
	"yellow": "Buildings-module__yellow___zgJOI",
	"orange": "Buildings-module__orange___2tTYq",
	"sand": "Buildings-module__sand___2E4UV",
	"mint": "Buildings-module__mint___3Tsy5",
	"green": "Buildings-module__green___RlU0O",
	"purple": "Buildings-module__purple___3MlM5",
	"black": "Buildings-module__black___14H0B"
};